// @flow

import React, { Component } from 'react'

import './PushNotifications.css'

type Props = {
  pushOnOff: Boolean
}

/**
  * Diplay for push notifications
  * @class
  * @extends Component
*/
class PushNotifications extends Component<Props> {
  /** render function */
  render () {
    return (
      <div className='PushedDisplay box'>
        <h4>
          PUSH NOTIFICATIONS
          {this.props.pushOnOff ? <span>ON</span> : <span>OFF</span>}
        </h4>
      </div>
    )
  }
}

export default PushNotifications
